<template>
  <div id="site-header" :class="(mobileMenuOpen ? 'open' : '') + ' ' + headerSize">
    <b-container>
      <div class="brand">
        <router-link class="image" :to="{ name: 'homepage' }">
          <span v-html="logo"></span>
        </router-link>
      </div>

      <div class="menu">
        <div class="menu--content">
          <div class="menu--navigation">
            <navigation @toggle-menu="toggleMenu" />
          </div>
          <div v-if="authentication" class="menu--user">
            <user />
          </div>
          <!--<div class="menu--secondaryLogo"></div>-->
        </div>
      </div>
      <div class="toggle" @click="toggleMenu">
        <div v-html="hamburger"></div>
      </div>
    </b-container>
  </div>
</template>

<script>
import Vue from 'vue';
import Navigation from '@/components/header/navigation';
import User from '@/components/header/user';
import Router from '@/router';
import { is_authenticated, custom_event } from '@/utilities';
import { hamburger, info } from '@/components/svg/common';
import { svg_contacts_phone } from '@/components/svg/static-pages';
import { logo } from '@/components/svg/logos';

export default {
  name: 'site-header',
  components: {
    navigation: Navigation,
    user: User,
  },
  created() {
    this.router = Router;
    this.hamburger = hamburger;
    this.info = info;
    this.is_authenticated = is_authenticated;
    this.custom_event = custom_event;
    this.svg_contacts_phone = svg_contacts_phone;

    this.logo = logo;
  },
  computed: {
    authentication: {
      get() {
        return this.is_authenticated();
      },
    },
  },
  watch: {
    '$route.name': function () {
      this.setupHeaderGui();
    },
  },
  data() {
    return {
      headerSize: '',
      menu_search_input: '',
      mobileMenuOpen: false,
      config: Vue.prototype.$config,
    };
  },
  methods: {
    setupHeaderGui() {
      this.mobileMenuOpen = false;
      this.headerSize = 'large';
    },
    toggleMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
      if (this.mobileMenuOpen) {
        document.body.classList.add('menuOpen');
      } else {
        document.body.classList.remove('menuOpen');
      }
    },
  },
  mounted() {
    this.setupHeaderGui();
    this.is_authenticated();
  },
};
</script>

<style lang="scss">
#site-header {
  $header-position: relative;
  background: $white;
  border-bottom: 1px solid $light-gray;

  & > .container,
  & > .container-fluid {
    width: 100%;
    height: $page-header-mobile-height;
    position: $header-position;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .menu {
    display: none;
    opacity: 0;
    transition: all 1s ease-in-out;
    position: $header-position;
    height: 100vh;
    width: 100vw;
    background: #fff;
    top: 0;
    left: 0;

    &--content {
      height: 100%;
      width: 100%;
      padding: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      z-index: 999;

      @include media-breakpoint-down(md) {
        width: 100vw;
        background: #fff;
        position: fixed;
        left: 0;
        top: $page-header-mobile-height;
        bottom: 0;
      }
    }

    &--secondaryLogo {
      //order:30;
      margin-bottom: 40px;
      background: $white;
      @include customize-gradient(vertical);
    }

    &--navigation {
      //order:10;
      margin-bottom: 20px;
    }

    &--user {
      //order:20;
      margin-bottom: 10px;
      padding-top: 0 !important;
      padding-bottom: 0 !important;
    }

    &--lite {
      margin-bottom: 30px;
      text-align: center;
      * {
        color: $liteRed;
      }
    }

    @include media-breakpoint-up(lg) {
      display: flex;
      opacity: 1;
      height: auto;
      &--content {
        justify-content: flex-end;
      }
    }
  }

  .toggle {
    position: absolute;
    z-index: 1;
    width: 32px;
    height: 32px;
    top: 50%;
    right: $grid-gutter-width/2;
    transform: translateY(-50%);
    //margin:$grid-gutter-width/4 $grid-gutter-width/2;
    path {
      transition: $transition-base;
      //@include customize-fill("light");
      //fill:$white;
      &:nth-child(1) {
      }
      &:nth-child(2) {
      }
      &:nth-child(3) {
      }
    }

    svg {
      width: 100%;
      height: 100%;
    }

    @include media-breakpoint-up(lg) {
      display: none;
    }
  }

  @include media-breakpoint-up(lg) {
    .menu {
      background: transparent;

      &--item {
        box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.25);
        height: 60px;
        display: flex;
        align-items: center;
        padding: $grid-gutter-width/2 $border-radius-lg/3;
        margin-left: $grid-gutter-width;
        border-radius: $border-radius-lg;
      }

      &--content {
        flex-direction: row;
        align-items: center;
      }

      &--secondaryLogo {
        @extend .menu--item !optional;
        //order:10;
        margin-bottom: 0;
        //width:180px;

        //@include theme-gradient-brand();

        margin-right: -$grid-gutter-width;
        padding-left: 80px;
        border-radius: 45px;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        height: 90px;
        width: auto;

        padding-bottom: 0;
        padding-top: 0;
      }

      &--navigation {
        @extend .menu--item !optional;
        //order:20;
        margin-bottom: 0;
        background: $white;
      }

      &--user {
        @extend .menu--item !optional;
        //order:30;
        margin-bottom: 0;
        z-index: 1;
        background: $white;
        margin-left: 32px;
      }

      &--lite {
        margin: 0 0 0 32px;
        font-size: 28px;
        svg {
          transition: $transition-base;
        }
        &:hover {
          svg {
            transform: scale(1.2);
          }
        }
      }
    }

    //transizione per quando la pagina scrolla
    .menu--content,
    .holder,
    .image {
      transition: all 0.5s ease-in-out;
    }
  }

  .toggler {
    margin-left: 20px;
    cursor: pointer;
  }
}

#site-header.open {
  .menu {
    display: block;
    opacity: 1;
    //z-index:1;
  }
  .brand {
    //z-index:2;
  }
  .toggle path {
    //@include customize-fill("dark");

    &:nth-child(2) {
      opacity: 0;
    }

    &:nth-child(1) {
      transform: rotate(45deg) translateY(-24px) translateX(13px);
    }
    &:nth-child(3) {
      transform: rotate(-45deg) translateY(-7px) translateX(-24px);
    }
  }
}

body.menuOpen {
  @include media-breakpoint-down(md) {
    overflow: hidden;
  }
}

/*
    body.scrolling
    {
    }
    */

.menu--search,
.menu--phone {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  &--label {
    margin: 0 1rem;
    font-weight: bold;
    line-height: 120%;
    @include media-breakpoint-up(md) {
      text-align: right;
      //max-width: 240px;
      font-size: 12px;
      //white-space:nowrap;
      background: $white;
      height: 50px;
      border-radius: $border-radius-lg;
      display: flex;
      align-items: center;
      padding: 0 60px 0 26px;
      margin: 0;
      margin-right: -40px;
    }
  }
  &--icon {
    margin-left: 10px;
    svg path {
      fill: $text;
    }
  }
  .form-control {
    width: auto;
    border-radius: $border-radius-lg;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-top: 0;
    border-bottom: 0;
    border-right: 0;
    a,
    a * {
      color: $text !important;
      text-decoration: none;
    }
    .icon {
      display: inline-block;
      width: 16px;
      margin-right: 6px;
      margin-left: -12px;
      svg {
        max-width: 100%;
        height: auto;
      }
    }
  }
  .btn {
    height: 100%;
    padding: 0 20px 0 16px;
    font-size: 12px;
  }
  &--input.input-group {
    width: auto;
  }
}
</style>
